import { AppButton, Modal, ModalHeader } from '@clickguard/design-system'

interface ZeroSpendModalProps {
	open: boolean
	onSelectDifferentAccount: () => void
}

export const ZeroSpendModal = ({ open, onSelectDifferentAccount }: ZeroSpendModalProps) => {
	return (
		<Modal
			open={open}
			onClose={onSelectDifferentAccount}
			closeOnOverlayClick={false}
			closeOnEscape={false}
			size="md"
			rounded="modal"
			// Force above the post-onboarding add-account GDialog (z-[10000001]).
			overlayClassName="!z-[10000002]"
			className="px-12 py-8"
		>
			<div className="flex flex-col gap-6">
				<ModalHeader
					size="lg"
					titleColor="navy"
					// ModalHeader has no 24px size (sm 20 / md 30 / lg 36); pin the title to the Figma 24/30.
					className="[&_h2]:!text-[24px] [&_h2]:!leading-[30px] [&_h2]:!tracking-normal"
					title="This account has no recent ad spend"
					subtitle="To protect your campaigns, we need an account that's actively spending. Select one that is currently running campaigns to continue."
				/>
				<AppButton
					variant="primary"
					size="lg"
					fullWidth
					label="Select a different account"
					onClick={onSelectDifferentAccount}
				/>
			</div>
		</Modal>
	)
}

export default ZeroSpendModal
